import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";

/**
 * User dashboard service
 */
@Injectable({
  providedIn: 'root'
})

export class ValoremIntegrationService {
  /**
   * Constructor
   * @param httpClient HttpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
  }

  /**
   * Publish valuation event to Valorem
   * @param valuationEventId Valuaiton event id
   */
  publish(valuationEventId: number) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.valorem.integration.api', "valoremIntegration/send/valuation"), { Oid: valuationEventId }).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
